import {
  useAppContext,
  useGetSurvey,
  useSubmitSurvey,
} from '@frx/frx-react-context';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Flex,
  Heading,
  Stack,
} from '@chakra-ui/react';
import { useContactSurveyId } from '../../hooks';
import { Loader, Notification, QuestionsForm } from '../../components';

export type SurveyFormData = {
  [key: string]: string;
};

export const ContactUs = () => {
  const {
    data: {
      eventData: { eventConfig },
    },
  } = useAppContext();
  const {
    mutate: submitSurvey,
    isLoading,
    data: submitRes,
  } = useSubmitSurvey();
  const surveyId = useContactSurveyId({ categoryId: eventConfig?.categoryId });
  const { data: surveyData } = useGetSurvey(
    { survey_id: surveyId },
    { enabled: !!surveyId }
  );
  const surveyQuestions =
    surveyData?.survey?.surveyQuestions.filter((sq) => sq.questionId) || [];

  const onSubmit = (data: SurveyFormData) =>
    submitSurvey(
      { survey_id: surveyId, ...data },
      { onSuccess: () => window.scrollTo(0, 0) }
    );

  return (
    <Stack align="center" spacing={4}>
      <Heading>Contact Us</Heading>
      {submitRes?.success && (
        <Notification
          status="success"
          message="Your message has been sent successfully. Thank you for taking the time to contact us."
        />
      )}
      {surveyQuestions ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {surveyQuestions?.length > 0 ? (
            <QuestionsForm
              hasSubmit
              questions={surveyQuestions || []}
              onSubmit={onSubmit}
              submitButtonProps={{ isLoading }}
            />
          ) : (
            <Alert
              status="warning"
              variant="subtle"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              height="200px"
            >
              <AlertIcon boxSize="40px" mr={0} />
              <AlertTitle mt={4} mb={1} fontSize="lg">
                Contact Us
              </AlertTitle>
              <AlertDescription maxWidth="sm">
                We apologize, but the selected Survey is currently unavailable
              </AlertDescription>
            </Alert>
          )}
        </>
      ) : (
        <Flex alignItems="center" justifyContent="center" h="50vh" w="100vw">
          <Loader />
        </Flex>
      )}
    </Stack>
  );
};
